const Terms = () => {
  return (
    <div className="min-h-screen bg-background pt-32 pb-20" data-testid="terms-page">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-3xl md:text-4xl font-medium text-foreground mb-8">
            Terms of Service
          </h1>
          
          <div className="prose prose-slate max-w-none">
            <p className="text-muted-foreground leading-relaxed mb-6">
              Last updated: February 2026
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">
              About Our Service
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Portugal Elite Estates provides a property search service for international buyers 
              interested in purchasing property in Portugal. We conduct searches based on your 
              requirements and present relevant opportunities for your consideration.
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">
              Nature of Service
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Our service is informational and introductory in nature. We help connect buyers with 
              properties and sellers in the Portuguese market. We are not a licensed real estate 
              agency and do not handle legal transactions, contracts, or financial arrangements 
              directly.
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">
              No Guarantees
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              While we strive to present accurate and relevant information, we make no guarantees 
              regarding the availability, price, condition, or suitability of any property. 
              All property information should be independently verified.
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">
              Professional Advice
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              We recommend that all buyers seek independent legal, financial, and tax advice 
              before making any property purchase in Portugal. Our service does not constitute 
              legal, financial, or tax advice.
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">
              Limitation of Liability
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Portugal Elite Estates shall not be liable for any direct, indirect, incidental, 
              or consequential damages arising from the use of our service or reliance on 
              information provided.
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">
              Changes to Terms
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              We reserve the right to modify these terms at any time. Continued use of our 
              service following any changes constitutes acceptance of the new terms.
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">
              Contact
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              For any questions about these Terms, please use our contact form.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
